import { ITimeSelect } from '@models/TimeSelect';
import { COLORS, TIME_ZONE } from 'global/Global';
import moment, { Moment } from 'moment';

interface IHelpers {
  // Delay theo ms cho các hàm async-await
  DelayTime(time: number): Promise<any>;
  /**
   * Kiểm tra số điện thoại có hợp lệ ko
   */

  // Hàm công trừ giờ
  ConvertAdd7Hours: (time: any, hours: number, type?: string) => any;

  ValidatePhone: (phone: string) => boolean;
  /**
   * Chuyển dạng number tiền sang định dạng tiền
   * @param money Số tiền
   * @param isUnit là true thì k hiện đơn vị tiền
   * @returns
   */
  FormatMoney: (money: number, isUnit?: boolean) => string;

  isNumeric: (string: any) => boolean;

  /**
   * Chuyển trạng thái đơn tất cả, chờ xn, đang thực hiện, hẹn lại sau, hoàn thành, huỷ  => text, color
   * @param value
   * @param isColorValue
   * @returns
   */
  ConvertStatusOrderToText: (value: string, isColorValue?: boolean) => any;

  /**
   * Chuyển dạng string UTC time sang định dạng thời gian địa phương
   * @param time Time UTC string
   * @returns
   */
  ConvertTimeUTCToStringLocal: (time: string) => string;

  /**
   * Chuyển dạng string UTC time sang định dạng thời gian Z cho datePicker
   * @param time Time UTC string
   * @returns
   */
  ConvertTimeUTCToDatePicker: (time: string) => any;

  /**
   * Chuyển thời gian từ Date sang ISOstring để gửi về lại server
   * Chủ yếu dùng chuyển ngày từ lịch chọn..
   * @param time Date
   */
  ConvertDateToISOString: (time: Date, onlyDate?: boolean) => string;

  /**
   * Chuyển thời gian từ Date sang Moment để gửi về lại server
   * Chủ yếu dùng chuyển ngày từ lịch chọn..
   * @param time Date
   */
  ConvertDateToMoment: (time: Date) => any;

  /**
   * Chuyển role value sang dạng text
   */
  FormatRoleTitle: (role: any, getColor?: any, getAll?: any, wareHouseType?: any) => any;

  /**
   * Chuyển thời gian từ lịch huyền thoại sang dạng ISO string
   */
  FormatTimeToISOStringSave: (selectTime: string[]) => any;

  /**
   * Merger đơn SC-BH
   */
  mergeErrorItems: (selectTime: string[]) => any;

  /**
   * Lấy tên user với mẫu vào avatar
   */
  FormatNameAccountAvt: (name?: string, userName?: string, type?: 'name' | 'userName') => any;

  /**
   * Hàm xử lý các khách hàng trùng mã với nhau trong 1 list các đơn
   */
  CalSameCustomer: (codeCuss: string[]) => any;

  /**
   * Chuyển số phút thành định dạng h 00:00:00
   */
  FomartTimeTotal: (t: number, noCalDay?: boolean) => any;
  // Hàm chia ngày ra giữa 2 ngày định dạng input là 3 biến vào ...
  EnumerateDaysBetweenDates: (startDate: Moment, endDate: Moment, stringTime: ITimeSelect, numSlit?: number) => any;

}

const Helpers: IHelpers = {
  async DelayTime(ms: number) {
    return await new Promise(resolve => setTimeout(resolve, ms));
  },
  EnumerateDaysBetweenDates: (startDate: Moment, endDate: Moment, stringTime: ITimeSelect, numSlit?: number) => {
    const dates: string[] = [];
    const step = numSlit || 1;

    for (let m = moment(startDate); m.isBefore(endDate); m.add(step, 'days')) {
      dates.push(m.toISOString()); // format chuẩn
    }

    // Xử lý logic
    dates.pop();
    dates.shift();

    dates.unshift(stringTime.beginTime);
    dates.push(stringTime.endTime);

    return dates;
  },

  ValidatePhone: (phone: string) => {
    const re = /((09|03|07|08|05|01|02|19)+([0-9]{6,9})\b)/gm;
    return re.test(String(phone).toLowerCase());
  },

  FormatMoney: (money?: number, isUnit?: boolean) => {
    const pieces = parseFloat(money ? money.toString() : '0')
      .toFixed(0)
      .split('');
    let ii = pieces.length;
    while ((ii -= 3) > 0) {
      pieces.splice(ii, 0, ',');
    }
    return pieces.join('').replace('-,', '-') + (!isUnit ? '₫' : '');
  },

  isNumeric: (value: any) => {
    return /^-?\d+$/.test(value);
  },

  /**
   * Chuyển trạng thái đơn tất cả, chờ xn, đang thực hiện, hẹn lại sau, hoàn thành, huỷ  => text, color
   * @param value
   * @param isColorValue
   * @returns
   */
  ConvertStatusOrderToText: (value: string, isColorValue?: boolean) => {
    if (isColorValue) {
      switch (value) {
        case '0':
          return 'unset'; // trắng
        case '1':
          return '#F39C12'; // vàng
        case '2':
          return '#006c87'; //  xanh biển 0
        case '3':
          return '#979797'; // xám
        case '4':
          return '#008000'; //  xanh lá
        case '5':
          return '#f50815'; // đỏ đô đậm
        case '6':
          return '#b06f09'; // vàng đậm
        case '7':
          return '#00BFFF'; // xanh biển 1
        case '8':
          return '#0069cb'; // xanh biển 2
        case '9':
          return '#0069cb'; // xanh biển 2
        case '10':
          return '#db856c'; // đỏ nhạt
        case '11':
          return '#6974a0'; // tím nhạt
        default:
          break;
      }
    }
    switch (value) {
      case '0':
        return ''; // OrganizedSales.OrderManager.TabName.AllOrder
      case '1':
        return 'OrganizedSales.OrderManager.TabName.WaitApproveOrder';
      case '2':
        return 'OrganizedSales.OrderManager.TabName.InProcessOrder';
      case '3':
        return 'OrganizedSales.OrderManager.TabName.HoldOnOrder';
      case '4':
        return 'OrganizedSales.OrderManager.TabName.CompleteOrder';
      case '5':
        return 'OrganizedSales.OrderManager.TabName.CancelOrder';
      case '6':
        return 'OrganizedSales.OrderManager.TabName.DeclineOrder';
      case '7':
        return 'OrganizedSales.OrderManager.TabName.GetOrder';
      case '8':
        return 'OrganizedSales.OrderManager.TabName.WaitEnter';
      case '9':
        return 'OrganizedSales.OrderManager.TabName.WaitRepair';
      case '10':
        return 'OrganizedSales.OrderManager.TabName.ConfirmShip';
      case '11':
        return 'OrganizedSales.OrderManager.TabName.WaitShip';
      default:
        return '';
    }
  },

  ConvertTimeUTCToStringLocal: (time: string) => {
    return moment(new Date(time)).format('HH:mm:ss DD/MM/YYYY');
  },

  // chưa rõ đúng hay sai
  ConvertTimeUTCToDatePicker: (time: string) => {
    return moment(new Date(time).toISOString(), 'YYYY-MM-DDThh:mm:ss.000Z');
  },

  ConvertDateToMoment: (time: Date) => {
    return moment(time).format('YYYY-MM-DDTHH:mm:ss')
  },

  ConvertDateToISOString: (time: Date, onlyDate?: boolean) => {
    return onlyDate
      ? new Date(time).toISOString().split('T')[0] + 'T00:00:00.000Z'
      : new Date(time.getTime() + TIME_ZONE * 60 * 60 * 1000).toISOString();
  },

  ConvertAdd7Hours: (time: any, hours: number, type?: string) => {
    const newDate = new Date(time);
    if (type === 'add') {
      newDate.setHours(newDate.getHours() + hours);
    } else {
      newDate.setHours(newDate.getHours() - hours);
    }
    return newDate;
  },

  FormatRoleTitle: (role: any, getColor?: any, getAll?: any, wareHouseType?: any) => {
    if (getColor) {
      switch (role) {
        case 'Root':
          return getAll ? { text: 'Administrator.AccountManager.Roles.Root', color: COLORS[12] } : COLORS[12];
        case 'Admin':
          return getAll ? { text: 'Administrator.AccountManager.Roles.Admin', color: COLORS[0] } : COLORS[0];
        case 'Accountant':
          return getAll ? { text: 'Administrator.AccountManager.Roles.Accountant', color: COLORS[35] } : COLORS[35];
        case 'BranchManager':
          return getAll ? { text: 'Administrator.AccountManager.Roles.BranchManager', color: COLORS[1] } : COLORS[1];
        case 'CustomerService':
          return getAll
            ? { text: 'Administrator.AccountManager.Roles.CustomerService', color: COLORS[25] }
            : COLORS[25];
        case 'Operating':
          return getAll ? { text: 'Administrator.AccountManager.Roles.Operating', color: COLORS[23] } : COLORS[23];
        case 'Sale':
          return getAll ? { text: 'Administrator.AccountManager.Roles.Sale', color: COLORS[2] } : COLORS[2];
        case 'Technician':
          return getAll ? { text: 'Administrator.AccountManager.Roles.Technician', color: COLORS[5] } : COLORS[5];
        case 'WareHouse':
          return getAll && wareHouseType === 1
            ? { text: 'Administrator.AccountManager.TypeWareHouse.Type1', color: COLORS[36] }
            : getAll && wareHouseType === 2
            ? { text: 'Administrator.AccountManager.TypeWareHouse.Type2', color: COLORS[36] }
            : { text: 'Administrator.AccountManager.TypeWareHouse.Type3', color: COLORS[36] };
        default:
          return getAll ? { text: 'Administrator.AccountManager.Roles.UnKnown', color: COLORS[6] } : COLORS[6];
      }
    }
    switch (role) {
      case 'Root':
        return 'Administrator.AccountManager.Roles.Root';
      case 'Admin':
        return 'Administrator.AccountManager.Roles.Admin';
      case 'Accountant':
        return 'Administrator.AccountManager.Roles.Accountant';
      case 'BranchManager':
        return 'Administrator.AccountManager.Roles.BranchManager';
      case 'CustomerService':
        return 'Administrator.AccountManager.Roles.CustomerService';
      case 'Operating':
        return 'Administrator.AccountManager.Roles.Operating';
      case 'Sale':
        return 'Administrator.AccountManager.Roles.Sale';
      case 'Technician':
        return 'Administrator.AccountManager.Roles.Technician';
      case 'WareHouse':
        return 'Administrator.AccountManager.Roles.WareHouse';
      default:
        return 'Administrator.AccountManager.Roles.Unknown';
    }
  },
  mergeErrorItems(errorItems: any[]) {
    const merged: any[] = [];

    for (const item of errorItems) {
      // Tìm tất cả object trùng id + oldSerial + registrationPlate (hoặc key bạn muốn)
      const duplicates = merged.filter(m =>
        m.id === item.id
        // && m.oldSerial === item.oldSerial
        // && m.registrationPlate === item.registrationPlate
        // ...
      );

      if (duplicates.length === 0) {
        // chưa có → push mới
        merged.push({ ...item });
      } else {
        // merge vào tất cả duplicates (trường hợp bạn muốn dồn toàn bộ về 1 object)
        const existing = duplicates[duplicates.length - 1]; // giữ lại 1 object làm gốc

        // Gộp diagnosis
        if (item.diagnosis) {
          if (existing.diagnosis) {
            existing.diagnosis += ';' + item.diagnosis;
          } else {
            existing.diagnosis = item.diagnosis;
          }
        }

        // Gộp handling
        if (item.handling) {
          if (existing.handling) {
            existing.handling += ';' + item.handling;
          } else {
            existing.handling = item.handling;
          }
        }

        // Gộp details
        if (Array.isArray(item.details) && item.details.length > 0) {
          if (!Array.isArray(existing.details)) existing.details = [];
          existing.details.push(...item.details);
        }

        // Ưu tiên field không rỗng
        for (const key of Object.keys(item)) {
          if (existing[key] === '' || existing[key] === null || existing[key] === undefined) {
            existing[key] = item[key];
          }
        }
      }
    }

    return merged;
  },

  FormatTimeToISOStringSave(selectTime: string[]) {
    const beginTime = selectTime[0].split(' ');
    const endTime = selectTime[1].split(' ');
    const packBeginTime = beginTime[0] + ':00 ' + beginTime[1];
    const packEndTime = endTime[0] + ':59 ' + endTime[1];
    // thêm bước chuyển ngày sang dạng iso string

    return [
      Helpers.ConvertDateToISOString(new Date(packBeginTime)),
      Helpers.ConvertDateToISOString(new Date(packEndTime))
    ];
  },
  FormatNameAccountAvt: (name?: string, userName?: string, type?: 'name' | 'userName') => {
    const useName = type == 'userName' ? userName : name;
    // cần xử lý thêm nếu lấy theo name (cắt các chữ cái đầu)
    return useName.split('.')[1]?.substring(0, 3)?.toUpperCase() || 'OM';
  },
  CalSameCustomer: (codeCuss: string[]) => {
    const countCus: any = {};
    codeCuss.forEach(i => {
      countCus[i] = (countCus[i] || 0) + 1;
    }); // tính số lần từng kh

    const count_keys = Object.keys(countCus).filter(cus => countCus[cus] !== 1);
    const lastCountCus = {};
    count_keys.forEach(key => (lastCountCus[key] = countCus[key])); // loại bỏ các kh nào chỉ xuất hiện 1 lần

    const sortable = Object.entries(lastCountCus)
      .sort(([, a]: any, [, b]: any) => b - a)
      .reduce((r, [k, v]) => ({ ...r, [k]: v }), {}); // sắp xếp lại dữ liệu trong object
    // console.log('codeCuss: ', Object.keys(sortable), sortable, countCus);
    return Object.keys(sortable) || [];
  },

  FomartTimeTotal: (t: number, noCalDay?: boolean) => {
    const giay = Math.floor((t * 60) % 60);
    const phut = Math.floor(t % 60);
    let hour = Math.floor(t / 60);
    if (noCalDay) {
      return `${hour < 10 ? '0' + hour : hour}:${phut < 10 ? '0' + phut : phut}:${giay < 10 ? '0' + giay : giay}`;
    }
    const day = Math.floor(hour / 24);
    hour = Math.floor(hour % 24);
    if (day !== 0) {
      return `${day}.${hour < 10 ? '0' + hour : hour}:${phut < 10 ? '0' + phut : phut}:${
        giay < 10 ? '0' + giay : giay
      }`;
    } else {
      return `${hour < 10 ? '0' + hour : hour}:${phut < 10 ? '0' + phut : phut}:${giay < 10 ? '0' + giay : giay}`;
    }
  }
};

export default Helpers;
